import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const getWarrantiesByFilter = (type, dealer, params) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/warranties/query?type=${type}&dealer=${dealer}${params}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_TWC_WARRANTIES,
        ActionTypes.FETCHED_TWC_WARRANTIES,
        [ActionTypes.FETCHED_TWC_WARRANTIES_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};


export const getWarrantiesStatus = () => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/warranties/status',
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_TWC_WARRANTIES_STATUS,
        ActionTypes.FETCHED_TWC_WARRANTIES_STATUS,
        [ActionTypes.FETCHED_TWC_WARRANTIES_STATUS_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const getWarrantyImages = (code, dealerId) =>
  apiActionCreator({
    'endpoint': `/warranties/${code}/${dealerId}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_TWC_WARRANTY_ATTACHMENTS,
      ActionTypes.FETCHED_TWC_WARRANTY_ATTACHMENTS,
      [ActionTypes.FETCHED_TWC_WARRANTY_ATTACHMENTS_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'form',
    'method': 'GET',
  });


export const getWarrantyByCode = (code, numTwc, dealer) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/warranties/${code}/${numTwc}/${dealer}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_TWC_WARRANTIES_BY_ID,
        [
          (response) => {
            dispatch(getWarrantyImages(code, dealer));
            return {
              'type': ActionTypes.FETCHED_TWC_WARRANTIES_BY_ID,
            };
          },
        ],
        [ActionTypes.FETCHED_TWC_WARRANTIES_BY_ID_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const clearWarranty = () => {
  return {
    'type': ActionTypes.CLEAR_WARRANTY,
  };
};

export const clearWarranties = () => {
  return {
    'type': ActionTypes.CLEAR_WARRANTIES,
  };
};

export const clearAddedWarranty = () => {
  return {
    'type': ActionTypes.CLEAR_ADDED_WARRANTY,
  };
};

export const getWarrantyAgency = () => {
  return apiActionCreator({
    'endpoint': '/warranties/twc-agencies',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_TWC_AGENCIES,
      ActionTypes.FETCHED_TWC_AGENCIES,
      [ActionTypes.FETCHED_TWC_AGENCIES_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};
